import React from 'react';
import { View, StyleSheet } from 'react-native';

import PhotoUploads from '../../ExpenseWidget/PhotoUploads';
import { useReceiptSelection } from '../../../utils/useReceiptSelection';
import { useRoute, useNavigation } from '@react-navigation/native';
import Button from '../../Button';
import { CommonProperties, CommonStyles } from '../../../styles';
import { scale, scaleVertically } from '../../../utils/scale.utils';
import { useDispatch, useSelector } from 'react-redux';
import { setReceiptsState } from '../../../store/actions/expense';
import { selectExpenseStates } from '../../../store/selectors/expense.selector';
import { useUpdateExpenseFromReceipts } from '../../../utils/useUpdateExpenseFromReceipts';

const ReceiptVaultModal = () => {
  const route = useRoute();
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const { actionType, subTab, updateExpenseState } = route.params;
  const expenseStates = useSelector(selectExpenseStates)[actionType][subTab];
  const { updateExpenseWithReceiptsData } = useUpdateExpenseFromReceipts();
  const receipts = expenseStates?.receipts;
  const { selectedImages, toggleSelectImage } = useReceiptSelection(receipts);

  const onSelect = () => {
    dispatch(setReceiptsState(selectedImages, actionType, subTab));
    if (updateExpenseState) {
      updateExpenseWithReceiptsData(selectedImages, actionType, subTab);
    }
    navigation.goBack();
  };

  return (
    <View style={styles.container}>
      <PhotoUploads toggleSelectImage={toggleSelectImage} selectedImages={selectedImages} />
      <Button
        label="Select"
        style={styles.submitButton}
        labelStyle={CommonStyles.buttonFont}
        onPress={onSelect}
        disabled={false}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: 'relative',
  },
  submitButton: {
    ...CommonProperties.py2,
    ...CommonProperties.shadow,
    ...CommonProperties.borderRadius4,
    ...CommonProperties.mx4,
    ...CommonProperties.mb4,
    position: 'absolute',
    bottom: scaleVertically(15),
    left: 0,
    right: 0,
  },
});

export default ReceiptVaultModal;
